import React, { PureComponent } from 'react'

import CardContainer from 'components/cards/containers/CardContainer'
import FeedbackCardTemplate from './FeedbackCardTemplate'
import FeedbackCardView from './FeedbackCardView'
import FeedbackCardEdit from './FeedbackCardEdit'

class FeedbackCardItem extends PureComponent {
	render() {
		const { node, actionHandler, allowEdit } = this.props;

		return (
			<CardContainer
				node={node}
				actionHandler={actionHandler}
				ViewComponent={!allowEdit && FeedbackCardView}
				EditComponent={allowEdit && FeedbackCardEdit}
				TemplateComponent={allowEdit && FeedbackCardTemplate}
			/>
		);
	}
}

export default FeedbackCardItem;


// WEBPACK FOOTER //
// ./src/components/cards/feedback/default/FeedbackCardItem.jsx